var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ready)?_c('div',[(_vm.order.id)?_c('div',[_c('b-row',[_c('b-col',[_c('orders-order-summary')],1),_vm._v(" "),_c('b-col',{staticClass:"single-order-edit",attrs:{"md":"8"}},[(_vm.viewMode === 'edit')?_c('orders-edit-order'):_vm._e(),_vm._v(" "),(_vm.viewMode === 'view')?_c('orders-view-order'):_vm._e()],1)],1)],1):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }